import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { aboutBio } from '../data/aboutData';
import joePhoto from '../images/joeWellsSeated.webp';

// Create motion components
const MotionFlex = motion(Flex);
const MotionBox = motion(Box);

/**
 * Top of the About page: a photo of Joe beside his name, title, and bio
 */
export default function AboutIntro() {
	return (
		<Flex
			width={{ base: "90%", lg: "80%" }}
			maxWidth={"1000px"}
			margin={"auto"}
			paddingBottom={{ base: 10, md: 16 }}
			// Photo on the left on desktop, so Joe (looking right in the photo) faces the bio
			// Side by side only on laptops and up; phones and iPads stack the photo above the text
			flexDirection={{ base: "column", lg: "row" }}
			alignItems={"center"}
			gap={{ base: 8, lg: 12 }}
		>
			{/* Photo */}
			<MotionBox
				flexShrink={0}
				width={{ base: "85%", sm: "65%", lg: "45%" }}
				// Keeps the stacked photo from getting too tall on iPads
				maxWidth={{ base: "420px", lg: "none" }}
				initial={{ opacity: 0, x: -50 }}
				animate={{ opacity: 1, x: 0 }}
				transition={{ duration: 0.7, ease: "easeOut" }}
			>
				<Image
					src={joePhoto}
					alt="Joe Wells"
					width={"100%"}
					aspectRatio={4 / 5}
					objectFit={"cover"}
					borderRadius={"xl"}
					boxShadow={"lg"}
				/>
			</MotionBox>

			{/* Name, Title, Bio */}
			<MotionFlex
				flexDirection={"column"}
				// Centered on phones; left-aligned from iPads up
				alignItems={{ base: "center", md: "flex-start" }}
				textAlign={{ base: "center", md: "left" }}
				gap={4}
				initial={{ opacity: 0, y: 30 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
			>
				<Flex flexDirection={"column"} gap={1}>
					<Text
						fontFamily={"Montserrat"}
						fontSize={"sm"}
						fontWeight={600}
						letterSpacing={"wider"}
						textTransform={"uppercase"}
						color={"yellow.100"}
					>
						Board-Certified Criminal Defense Attorney
					</Text>
					<Text
						fontFamily={"Martel"}
						fontWeight={"700"}
						fontSize={{ base: "32px", md: "40px" }}
						color={"white.500"}
					>
						Joe Wells
					</Text>
				</Flex>

				{aboutBio.map((paragraph) => (
					<Text
						key={paragraph}
						fontFamily={"Montserrat"}
						fontWeight={500}
						fontSize={{ base: "md", md: "lg" }}
						lineHeight={1.7}
						color={"white.500"}
					>
						{paragraph}
					</Text>
				))}
			</MotionFlex>
		</Flex>
	);
}
